import { getTimestampFromDateString } from "common/date-utils";
import { getPerformancePeriodAsStringIndex } from "common/types/performancePeriod";
const comparator = (valueA, valueB) => {
    if (!valueA && !valueB && valueA !== 0 && valueB !== 0) {
        return 0;
    }
    if (!valueA && valueA !== 0) {
        return -1;
    }
    if (!valueB && valueB !== 0) {
        return 1;
    }
    if (valueA === valueB) {
        return 0;
    }
    return valueA > valueB ? 1 : -1;
};
export const moneyComparator = (a, b) => {
    const valueA = a?.value ?? a?.amount;
    const valueB = b?.value ?? b?.amount;
    return comparator(valueA, valueB);
};
export const areaComparator = (a, b) => {
    const valueA = a?.value ?? a?.area;
    const valueB = b?.value ?? b?.area;
    return comparator(valueA, valueB);
};
export const unitComparator = (a, b) => {
    const valueA = a?.value ?? a?.unit;
    const valueB = b?.value ?? b?.unit;
    return comparator(valueA, valueB);
};
const dateFromValue = (date) => {
    if (date && typeof date === "object") {
        const { day, month, year } = date;
        if (day && month && year) {
            return new Date(Date.UTC(year, month - 1, day));
        }
    }
    const result = new Date(getTimestampFromDateString(date));
    return isNaN(result.getTime()) ? null : result;
};
const isPlainObject = (value) => value && typeof value === "object" && !(value instanceof Date);
const parseObjectDateTime = (obj) => {
    const { day, month, year } = obj || {};
    const hasTime = (obj?.hours !== undefined) || (obj?.minutes !== undefined) || (obj?.seconds !== undefined);
    if (day && month && year && hasTime) {
        const hours = obj?.hours ?? 0;
        const minutes = obj?.minutes ?? 0;
        const seconds = obj?.seconds ?? 0;
        const d = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
        return isNaN(d.getTime()) ? null : d;
    }
    return null;
};
const dateTimeFromValue = (date) => {
    if (date instanceof Date) {
        return isNaN(date.getTime()) ? null : date;
    }
    if (isPlainObject(date)) {
        const parsed = parseObjectDateTime(date);
        if (parsed) {
            return parsed;
        }
    }
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d;
};
export const getDateComparator = (inverted = false) => (a, b) => {
    const dateA = inverted ? dateFromValue(b) : dateFromValue(a);
    const dateB = inverted ? dateFromValue(a) : dateFromValue(b);
    if (dateA === dateB) {
        return 0;
    }
    if (!dateA || !dateB) {
        return dateA ? 1 : -1;
    }
    if (dateA.valueOf() === dateB.valueOf()) {
        return 0;
    }
    return dateA > dateB ? 1 : -1;
};
export const getDateTimeComparator = (inverted = false) => (a, b) => {
    const dateA = inverted ? dateTimeFromValue(b) : dateTimeFromValue(a);
    const dateB = inverted ? dateTimeFromValue(a) : dateTimeFromValue(b);
    if (dateA === dateB) {
        return 0;
    }
    if (!dateA || !dateB) {
        return dateA ? 1 : -1;
    }
    const valA = dateA.valueOf();
    const valB = dateB.valueOf();
    if (valA === valB) {
        return 0;
    }
    return valA > valB ? 1 : -1;
};
export const performancePeriodDefaultComparator = (valueA, valueB) => (getPerformancePeriodAsStringIndex(valueA) ?? 0) - (getPerformancePeriodAsStringIndex(valueB) ?? 0);
// Still in use in analytics @TODO remove it when analytics is no longer used
export const performancePeriodComparator = (performancePeriod) => (a, b) => performancePeriod.indexOf(a) - performancePeriod.indexOf(b);
export const valueComparator = (a, b) => {
    const valueA = a?.value ?? a;
    const valueB = b?.value ?? b;
    return comparator(valueA, valueB);
};
export const idToNameComparator = (a, b, na, nb) => {
    if (na.field && nb.field && na.aggData?.[na.field] && nb.aggData?.[nb.field]) {
        return comparator(na.aggData[na.field], nb.aggData[nb.field]);
    }
    return comparator(a, b);
};
